import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';
import {
    getPortfolioSummaryChartSeriesData,
    PortfolioSummaryChartSeriesData,
} from './portfolioSummaryChartSeriesData';
import { PortfolioSummaryAggregatedData } from 'widgets/portfolioSummary/store/data/PortfolioSummaryDataState';
import { PortfolioSummarySideNetOptions } from '../../store/instances/configuration/PortfolioSummaryConfigurationState';
import {
    PortfolioSummaryChartDimensions,
    calculateDimensions,
} from './dimensions';
import {
    toPortfolioSummaryChartBarData,
    PortfolioSummaryChartBarsData,
} from './portfolioSummaryChartBarData';
import { QuantitiesOptions } from 'utils/components/QuantitiesOptions/QuanitiesOptions';

export interface PortfolioSummaryChartData {
    chartData: PortfolioSummaryChartSeriesData;
    dimensions: PortfolioSummaryChartDimensions;
}

export function computeChartData(
    aggregationField: AggregationField,
    exchangeRate: number,
    aggregatedData: PortfolioSummaryAggregatedData | undefined,
    showBuysAsPositive: boolean,
    plotAreaHeight: number,
    quantities: QuantitiesOptions,
    sideNet: PortfolioSummarySideNetOptions,
    combineSellsAndShorts: boolean
): PortfolioSummaryChartData {
    const chartBarData = toPortfolioSummaryChartBarData(
        aggregationField,
        exchangeRate,
        aggregatedData,
        showBuysAsPositive,
        quantities,
        combineSellsAndShorts
    );

    const dimensions = calculateDimensions(
        chartBarData?.groupNames.length,
        plotAreaHeight
    );

    const truncatedData = truncateGroups(
        chartBarData,
        dimensions.displayGroupCount
    );

    const chartData = getPortfolioSummaryChartSeriesData(
        truncatedData,
        sideNet
    );

    return { chartData, dimensions };
}

export function truncateGroups(
    data: PortfolioSummaryChartBarsData,
    count: number
): PortfolioSummaryChartBarsData {
    // The arrays are sorted by ascending value so we need the end..
    const from = Math.max(data.groupNames.length - count, 0);
    const groupNames = data.groupNames.slice(from);
    return {
        groupNames,
        buy: data.buy.filter((b) => groupNames.indexOf(b.groupName) > -1),
        sell: data.sell.filter((b) => groupNames.indexOf(b.groupName) > -1),
        net: data.net.filter((b) => groupNames.indexOf(b.groupName) > -1),
    };
}
